module.exports = __webpack_public_path__ + "img/robot-mini.5d37a8af.png";